import { extend } from '@thd-nucleus/data-sources';

import { AddToCart } from '@thd-olt-component-react/add-to-cart';

export const AddItemsToCartDataModel = extend(AddToCart);
